import React, { useContext } from 'react'
import { Grid as GridComponent, GridItem } from '@deal/components'
import type { GridItemProps } from '@deal/components'
import type { ResponsiveGridProps } from '@deal/components/es/components/Grid/Grid'
import { SidebarContext } from '#src/context/sidebar'
import classnames from 'classnames'
import styles from './styles.css'

export interface GridProps extends ResponsiveGridProps {
  // Force the Grid to be full-width, regardless of the presence of the sidebar
  // Useful for heros or other banners that should extend "under" the sidebar
  fullWidth?: boolean
}

const Grid: React.FC<GridProps> = ({ className, fullWidth, ...props }) => {
  const isSidebarVisible = useContext(SidebarContext)

  return (
    <GridComponent
      className={classnames(className, {
        [styles.sidebarAwareGrid]: isSidebarVisible && !fullWidth
      })}
      {...props}
    />
  )
}

export default Grid
export { GridItem }
export type { GridItemProps }
